<template>
  <div class="col-span-6">
    <label for="field.label" class="block 2xl:text-sm sm:text-xl font-medium leading-5 text-gray-700">
      {{field.label}}
    </label>
    <div class="mt-1 relative rounded-md shadow-sm">
      <input type="text" @input="waitUpdateValue(field.key, $event.target.value)" :value="formdata[field.key]" class="mt-1 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-lg 2xl:text-sm border-gray-300 rounded-md" :placeholder="field.placeholder"/>
    </div>
    <p v-if="validation !== undefined" class="mt-2 lg:text-base sm:text-lg text-red-600" id="email-error">* {{validation.msg}}</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      timer: undefined
    }
  },
  name: 'text-field',
  props: {
    field: {
      type: Object,
      required: true
    },
    formdata: {
      type: Object,
      required: true
    },
    validation: {
      type: Object,
      required: false
    }
  },
  watch: {
  },
  methods: {
    
    waitUpdateValue(key, value){
      clearTimeout(this.timer)
      this.timer = setTimeout( ()=> this.updateValue(key, value) , 1000)
    },
    updateValue(key, value) {
      console.log(value);
      this.$parent.updateValue(key, value)
    }
  }
}
</script>
